<template>
    <div class="list-container">
        <div class="air-header">
            <div :class="isDev ? 'title-logo' : 'title-logo-test'"></div>
            <div class="title-icon">
                <!-- <i class="icon icon-help"></i>
                <i class="icon icon-search"></i>
                <i class="icon icon-user"></i> -->
                <i class="icon icon-exit" @click="logOut"></i>
            </div>
        </div>
        <div class="list">
            <div class="list-item" v-for="(item, key) in projectData" :key="key" @click="handleClick(key)">
                <img class="image" :src="require(`../assets/images/plist/${item.logo}`)" />
                <div class="name">{{item.name}}</div>
                <!-- <div class="desc">{{item.desc}}</div>
                <div class="desc">{{item.date}}</div>
                <div class="desc">{{item.user}}</div>
                <div class="status" :class="item.status==='非公开'?'status1':''">{{item.status}}</div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProjectList",
    data() {
        return {
            isDev: false,  // false为非生产环境，true为生产环境
            projectData: window.project_config
        }
    },
    mounted(){
        if(location.href.indexOf('cockpit-dcpmp') > -1){
            this.isDev = true;
        }else{
            this.isDev = false;
        }
    },
    methods: {
        handleClick(key) {
            window.localStorage.setItem("project", key);
            this.$project.key = key
            this.$project.projectData = window.project_config[key]
            this.$axios.defaults.headers['organizeId'] = window.project_config[key].platform.organizeId;
            this.$axios.defaults.headers['PlanId'] = window.project_config[key].platform.progressLoadingPlanId;
            this.$router.push('/index');
        },
        logOut(){
            this.$confirm('确定退出当前账号', '操作确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.replace('/')
                window.localStorage.removeItem("Token");
            }).catch(() => {
                window.history.go(1)
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.list-container {
    width: 100%;
    height: 100%;
    background: #071129;
    display: flex;
    flex-direction: column;
    align-items: center;

    .air-header {
        width: 100%;
        height: 80px;
        line-height: 80px;
        margin: 0;
        border-bottom: 2px solid transparent;
        color: rgba(255, 255, 255, 0.72);
        background: transparent;
        .title-logo {
            width: 483px;
            height: 62px;
            /* margin: 9px 20px; */
            margin: 14px 20px 4px;
            background-repeat: no-repeat;
            background-image: url("../assets/images/title.png");
            background-size: 100%;
        }
        .title-logo-test {
            width: 483px;
            height: 62px;
            /* margin: 9px 20px; */
            margin: 25px 10px 0px;
            background-repeat: no-repeat;
            background-image: url("../assets/images/title-test.png");
            background-size: 100%;
        }
    }

    .list {
        width: 1656px;
        height: calc(100vh - 80px);
        margin-top: 50px;
        display: flex;
        flex-wrap: wrap;

        .list-item {
            position: relative;
            width: 384px;
            height: 426px;
            cursor: pointer;
            &:not(:nth-child(4n)) {
                margin-right: 40px;
            }
            .image {
                width: 100%;
                height: 260px;
                border-radius: 4px;
            }
            .name {
                font-size: 24px;
                font-weight: 500;
                color: #fff;
                margin: 20px 0;
            }
            // .desc {
            //     font-size: 18px;
            //     color: #C6C8D8;
            //     &:not(:first-child) {
            //         margin-top: 8px;
            //     }
            // }
            // .status {
            //     position: absolute;
            //     right: 0;
            //     bottom: 0;
            //     min-width: 52px;
            //     height: 30px;
            //     line-height: 30px;
            //     text-align: center;
            //     border-radius: 3px;
            //     border: 1px solid #26ABFF;
            //     color: #26ABFF;
            //     font-size: 18px;
            //     padding: 0 8px;
            // }
            // .status1 {
            //     border: 1px solid #FF6B50;
            //     color: #FF6B50;
            // }
        }
    }
}
</style>